export type SolutionType = {
  id: number;
  type: string;
  title: string;
  description: string;
  image: string;
  route: string;
};

export const solutions = [
  {
    id: 1,
    type: "url",
    title: "Website QR code",
    description:
      "Streamline access and amplify online presence with a personalized Website QR code. Drive engagement, boost traffic, and connect audiences with digital content. Integrate QR codes into marketing materials for instant access to promotions and information. Trackable and customizable URL QR codes offer valuable insights into user behavior, empowering digital strategy.",
    route: "/website-qr-code",
    image: "/solutions/website.webp",
  },
  {
    id: 2,
    type: "text",
    title: "Text QR code",
    description:
      "Share text-based information easily with a Text QR code. Facilitate communication by encoding plain text or messages. Ideal for product packaging, instructions, educational materials, and personal notes. Incorporate Text QR codes into various contexts to streamline interaction and elevate user experience.",
    route: "/text-qr-code",
    image: "/solutions/text.webp",
  },
  {
    id: 3,
    type: "pdf",
    title: "PDF QR code",
    description:
      "Generate a PDF QR code to simplify document sharing and enhance accessibility. Enable users to effortlessly access PDF files by scanning the code with smartphones. Integrate PDF QR codes into the workflow to streamline information dissemination. PDF QR codes offer a convenient way to distribute forms, brochures, and reports digitally, boosting efficiency and engagement.",
    route: "/pdf-qr-code",
    image: "/solutions/pdf.webp",
  },
  {
    id: 4,
    type: "wifi",
    title: "WiFi QR code",
    description:
      "Empower seamless connectivity with a WiFi QR code. Share WiFi network credentials with a simple scan, eliminating the hassle of manual input. Enhance user experience, simplify onboarding, and provide convenient access to the network. Integrate WiFi QR codes into business spaces or events to offer guests hassle-free internet access. Improve efficiency and automate connectivity with this innovative solution.",
    route: "/wifi-qr-code",
    image: "/solutions/wifi.webp",
  },
  {
    id: 5,
    type: "vcard",
    title: "Vcard QR code",
    description:
      "Optimize networking with a vCard QR code, effortlessly sharing contact details. Enhance connectivity and speed up communication with the vCard QR code solution. Integrate vCard QR codes into business cards, emails, and digital signatures for instant access to professional information. Capture leads and expand your network efficiently.",
    route: "/vcard-qr-code",
    image: "/solutions/vcard.webp",
  },
  {
    id: 6,
    type: "businesspage",
    title: "Business QR code",
    description:
      "Boost business visibility with a Business Page QR code. Promote engagement, boost traffic, and connect customers with business information. Integrate QR codes into marketing materials for instant access to promotions and contact details. Business Page QR codes offer valuable insights into customer interactions, empowering marketing strategy. Elevate the brand presence and simplify customer engagement with a single scan.",
    route: "/business-page-qr-code",
    image: "/solutions/business.webp",
  },
  {
    id: 7,
    type: "menu",
    title: "Menu QR code",
    description:
      "Integrate Menu QR codes into dining areas, offering patrons quick access to offerings and specials. Monitor customer preferences and adapt menus dynamically when needed. Elevate your dining establishment with Menu QR codes, delivering a modern, efficient, personalized experience.",
    route: "/restaurant-menu-qr-code",
    image: "/solutions/menu.webp",
  },
  {
    id: 8,
    type: "email",
    title: "Email QR code",
    description:
      "Generate an Email QR code linked directly to the email address, allowing instant contact with a scan. Integrate Email QR codes into displays, flyers, and digital signatures for quick access. Enhance networking, streamline inquiries, and foster connections effortlessly. Plus, trackable features offer valuable insights into email engagement, empowering communication strategy.",
    route: "/email-qr-code",
    image: "/solutions/email.webp",
  },
  {
    id: 9,
    type: "call",
    title: "Phone QR code",
    description:
      "Use Phone QR codes to automate mobile interactions effortlessly. A simple scan provides instant access to the phone number to initiate a call. Integrate Phone QR codes into business cards, posters, or advertisements for quick contact initiation. Elevate outreach strategy with Phone QR codes, ensuring swift and efficient connections with your audience.",
    route: "/phone-qr-code",
    image: "/solutions/phone.webp",
  },
  {
    id: 10,
    type: "sms",
    title: "SMS QR code",
    description:
      "Create QR codes linked directly to SMS messages, encouraging instant interaction. Integrate SMS QR codes into marketing materials to conveniently access promotions, offers, and customer support. Strengthen customer relationships and streamline communication channels with this innovative solution.",
    route: "/message-qr-code",
    image: "/solutions/sms.webp",
  },
  {
    id: 11,
    type: "images",
    title: "Images QR code",
    description:
      "Display stunning image collections and engage audiences with instant access. Integrate Image QR codes into marketing materials to provide immersive experiences and leave a lasting impression. The Image Gallery QR codes allow users to share and curate memorable visual stories, enhancing the brand's digital presence like never before.",
    route: "/images-qr-code",
    image: "/solutions/images.webp",
  },
  {
    id: 12,
    type: "video",
    title: "Video QR code",
    description:
      "Collect YouTube videos on one landing page with a QR code. Compile a curated selection of top YouTube content into a single, accessible platform through a custom QR code. Integrate this QR code into marketing materials to provide audiences with convenient access to diverse, engaging videos. QR code landing pages allow users to update and customize the video collection.",
    route: "/video-qr-code",
    image: "/solutions/video.webp",
  },
  {
    id: 13,
    type: "mp3",
    title: "Mp3 QR code",
    description:
      "Create a personalized landing page for the track or song, accessible with a simple scan. Integrate MP3 QR codes into promotions, giving audiences instant access to the latest release or curated music. Provide listeners with an unforgettable auditory experience.",
    route: "/music-qr-code",
    image: "/solutions/mp3.webp",
  },
  {
    id: 14,
    type: "app",
    title: "App QR code",
    description:
      "Facilitate app access via quick scans, enhancing efficiency and marketing reach. Elevate marketing strategy with the App QR code, directing users to a dedicated landing page. Accessible on Play Store, App Store, and Amazon, App QR codes simplify user journeys while maximizing reach. Integrate App QR codes into ads, packaging, events, and digital campaigns.",
    route: "/app-qr-code",
    image: "/solutions/app.webp",
  },
  {
    id: 15,
    type: "socialmedia",
    title: "Social Media QR code",
    description:
      "Elevate social media accounts with Social Media QR codes. Social Media QR code leads directly to a dedicated landing page showcasing all social media accounts—Facebook, Instagram, Twitter, LinkedIn, and more. Streamline networking, amplify your online presence, and engage the audience effortlessly. Simplify connectivity and supercharge the social media strategy. ",
    route: "/social-media-qr-code",
    image: "/solutions/socialmedia.webp",
  },
  {
    id: 16,
    type: "linkedin",
    title: "LinkedIn QR code",
    description:
      "Unlock the full potential of professional networking with LinkedIn QR Codes. Connect instantly with industry peers, potential employers, or clients by scanning and accessing the LinkedIn profile. Network effortlessly at events, conferences, or meetings, and expand your professional reach. Build meaningful connections, foster collaborations, and propel your career to new heights.",
    route: "/linkedin-qr-code",
    image: "/solutions/linkedin.webp",
  },
  {
    id: 17,
    type: "facebook",
    title: "Facebook QR code",
    description:
      "Transform the Facebook strategy with a Facebook QR code. Connect users to the Facebook page or specific posts, fostering engagement and interaction. Amplify your social media presence and expand audience reach with Facebook QR solution. Drive a deeper connection with customers, boost engagement, and become more visible online. ",
    route: "/facebook-qr-code",
    image: "/solutions/facebook.webp",
  },
  {
    id: 18,
    type: "event",
    title: "Event QR code",
    description:
      "Take your event to the next level with Event QR codes. Access comprehensive event information, effortlessly purchase tickets, and secure your spot hassle-free. Say goodbye to long queues and complicated booking processes. Event QR codes simplify event attendance, streamline ticket purchasing, and ensure a stress-free experience for attendees.",
    route: "/event-qr-code",
    image: "/solutions/event.webp",
  },
  {
    id: 19,
    type: "location",
    title: "Location QR code",
    description:
      "Create Location QR codes for instant navigation and exploration. Access precise location details, including addresses, directions, and nearby attractions, with a simple scan. Location QR code provides quick access to essential location information for travelers or locals seeking the best places in a city. Get lost no more with the Location QR code.",
    route: "/location-qr-code",
    image: "/solutions/location.webp",
  },
  {
    id: 20,
    type: "feedback",
    title: "Feedback QR code",
    description:
      "Drive engagement and gather valuable insights with Feedback QR codes. Create a customized Feedback QR code and empower the audience to share their thoughts effortlessly. Improve the quality of the products, services, and overall customer experience by providing an easy-to-use feedback mechanism. Start harnessing the power of feedback to improve and grow the business.",
    route: "/feedback-qr-code",
    image: "/solutions/feedback.webp",
  },
  {
    id: 21,
    type: "coupon",
    title: "Coupon QR code",
    description:
      "Create a Coupon QR code and unlock the potential to attract more customers, boost sales, and drive growth. Craft irresistible offers, promotions, and discounts that entice customers to choose your business over the competition. Track redemption rates, analyze customer behavior, and refine your marketing strategies with Coupon QR codes.",
    route: "/coupon-qr-code",
    image: "/solutions/coupon.webp",
  },
  {
    id: 22,
    type: "rating",
    title: "Rating QR code",
    description:
      "Empower the audience to provide valuable feedback with Rating QR codes. Gather insights, improve offerings, and enhance customer satisfaction. Rating QR codes allow customers to share their experiences easily, helping businesses tailor products or services to meet their needs better. Strengthen customer relationships and drive business growth.",
    route: "/rating-qr-code",
    image: "/solutions/rating.webp",
  },
  {
    id: 23,
    type: "bitcoin",
    title: "Crypto QR code",
    description:
      "Simplify crypto transactions. Receive cryptocurrencies from others by scanning Crypto Wallet QR codes. Transactions are seamless and convenient, including a personalized message and the desired amount. The Crypto Wallet QR Code makes receiving payments, donating funds, or transferring funds secure and efficient. Start using Crypto Wallet QR codes today for hassle-free transactions.",
    route: "/crypto-wallet-qr-code",
    image: "/solutions/crypto.webp",
  },
];
